import React, { Component, Fragment } from "react"
import styles from "./GalleryScreen.module.scss"
import { connect } from 'react-redux'
import Message from "../../domain/Message"
import { FaChevronLeft } from "react-icons/fa"
import ProfileImage from "../widgets/ProfileImage"
import headerStyles from "../chat/Header.module.scss"
import characters from "../../characters";
import ImageWithThumbnail from "../widgets/ImageWithThumbnail";
import { Link } from "@reach/router";

require("zoom-vanilla.js");

class GalleryScreen extends Component {

  state = { cheatMode: false };

  render() {
    const { storyName, storyImages, loading } = this.props;
    const profileImage = characters[storyName].profilePicture;
    const name = characters[storyName].name;

    return <Fragment>
      <div className={headerStyles.header}>
        <Link to={"/chat/" + storyName}>
          <FaChevronLeft className={headerStyles.icon}/>
        </Link>
        <span className={headerStyles.profileContainer}>
          <ProfileImage image={profileImage}/>
          {name}
        </span>
        <span className={headerStyles.icon}
              // onClick={() => this.setState({ cheatMode: !this.state.cheatMode })}
        />
      </div>

      <div className={styles.images}>
        {storyImages.map(it =>
          <div key={it.id} className={styles.image}>
            <ImageWithThumbnail
              src={it.isUnlocked || this.state.cheatMode ? it.getSourceFromImage() : "images/ui/locked-pic.png"}
              alt={'Image not unlocked'}/>
          </div>
        )}
      </div>
    </Fragment>;
  }
}

const mapState = (state, props) => {
  const storyName = props.storyName;
  const storyState = state[storyName];
  return {
    storyImages: storyState.imageGallery.map(it => new Message(it)),
    loading: state.loading.effects[storyName].resumeScheduledMessages
  };
};

const mapDispatch = (state, props) => {
  const storyDispatch = state[props.storyName];
  return { storyDispatch };
};

export default connect(mapState, mapDispatch)(GalleryScreen);